export default __webpack_public_path__ + "static/media/fad-automation-2p.952fccef.svg";